import { render, staticRenderFns } from "./ComponentNews.vue?vue&type=template&id=8aec4384&scoped=true"
import script from "./ComponentNews.vue?vue&type=script&lang=js"
export * from "./ComponentNews.vue?vue&type=script&lang=js"
import style0 from "./ComponentNews.vue?vue&type=style&index=0&id=8aec4384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aec4384",
  null
  
)

export default component.exports